const Music = ()  => {
  return <h1>Music</h1>
}

export default Music